import getOrigin from "./getOrigin";

const pathHtmlReg = /^https?:\/\//;

const needRedirectTo = true;

/**
 * 重定向，没有路由处理
 */
export default function redirectTo(path: string) {
  if (!needRedirectTo) return;
  if (pathHtmlReg.test(path)) {
    window.location.href = path;
    return;
  }
  const host = getOrigin();
  window.location.href = host + process.env.ROUTPATH +path;
}
